import React, { useEffect, useMemo, useState } from "react";
import TopLeft from "./TopLeft";
import _ from "underscore";
import { TimeEdit } from "../../lib/TimeEdit";
import API from "../../lib/TimeEditAPI";
import ErrorBoundary from "../ErrorBoundary";
import coreAPI from "./PrefsCoreAPI";
// Resolved by vite config
// eslint-disable-next-line import/no-unresolved
import "te-prefs-lib.css";
import { useAppContext } from "../../contexts/AppContext";
import LazyLoadWrapper from "../LazyLoadWrapper";
import { EAppEnv } from "@timeedit/types/lib/enums/appEnv.enum";
import { TComponent } from "../../types/utils";

const TEPrefsPlugin = React.lazy(() => import("@timeedit/te-prefs-lib"));

type TWrapperProps = {
    size?: { height: number; width: number };
    style?: React.CSSProperties;
    topLeft?: React.JSX.Element;
};

const Wrapper: TComponent<TWrapperProps> = (props) => {
    const appContext = useAppContext();
    const [toolbar, setToolbar] = useState<React.JSX.Element | null>(null);

    /**
     * Environment passed to TePrefsLib: one of "production", "staging", "beta",
     * "test", "development".
     */
    const env =
        process.env.NODE_ENV === "development" ? EAppEnv.DEVELOPMENT : appContext.env.serverEnv;

    const prefsCoreAPI = useMemo(
        () => coreAPI(props, appContext.user, setToolbar),
        [props, appContext.user]
    );

    useEffect(() => {
        if (process.env.NODE_ENV === "development") {
            TimeEdit.prefsAPI = coreAPI(props, appContext.user, undefined);
        }
        return () => {
            API.clearAmCaches();
        };
    }, []);

    return (
        <div className={"reservationList"} style={props.style}>
            <TopLeft topLeft={props.topLeft} contents={toolbar} />
            <ErrorBoundary>
                <div style={{ flexGrow: "1", overflow: "auto" }}>
                    <LazyLoadWrapper>
                        <TEPrefsPlugin
                            region={appContext.env.serverRegion}
                            env={env}
                            coreAPI={prefsCoreAPI}
                        />
                    </LazyLoadWrapper>
                </div>
            </ErrorBoundary>
        </div>
    );
};

export default React.memo(Wrapper, (prev, next) => _.isEqual(prev.size, next.size));
